import {Stack, Button, Alert } from '@mui/material';
import PictureIcon from '@mui/icons-material/InsertPhoto';
import { useState } from 'react';
import Tip from '../Tools/Tip';
import { useEffect } from 'react';
import { txt } from '../../services/translation';

export default function Pictures({label, onChange, value, max, maxSize, onDelete}){

    const maximum = max || 10;
    const [pictures, setPictures] = useState([])
    const [error, setError] = useState(false)
    const accept = ['image/png','image/jpeg','image/jpg'];

    let ms = maxSize || 1000000;

    useEffect(() => {
        setPictures(value || [])
    }, [value])

    const handleChange = e => {

        setError(false);

        let copy = [...pictures];
        
        for(let i = 0; i < e.target.files.length; i++){

            let img = e.target.files[i];

            if( !accept.includes(img.type) ){
                setError(txt('fileTypeNotAccepted', {name: img.name}));

            }else if( img.size > ms ){
                setError(txt('fileTooHeavy', {name: img.name}));

            }else{
                img.url = URL.createObjectURL(e.target.files[i]);
                copy.push(img)
            }
        }

        return onChange( copy.slice(0, maximum) );
    }


    const handleDelete = index => {
        let copy = [...pictures];
        onDelete(copy[index]);
        copy.splice(index, 1);
        return onChange( copy.slice(0, maximum) );
    }


    return <>

        <Button
            startIcon={<PictureIcon />}
            variant='outlined'
            onClick={() => document.getElementById('file-picker').click()}
        >
            {label || txt('addPictures')}
        </Button>
                
        <input 
            id='file-picker'
            name='file-picker'
            type="file"
            onChange={handleChange}
            style={{display: 'none'}}
            multiple
            accept={accept.join(',')}
        />

        {error && <Alert severity='error'>{error}</Alert>}

        <Stack direction='row' sx={{flexWrap: 'wrap'}}>

            {pictures.map((p, i) => 
                
                <div key={i + 1} style={{
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    backgroundImage: `url(${p.url})`,
                    width: 150,
                    height: 150,
                    marginRight: 10,
                    marginBottom: 10,
                    border: 'solid 1px lightgrey',
                    display: 'flex',
                    justifyContent: 'flex-end'
                }}>
                    <Tip type='delete' onClick={() => handleDelete(i)}/>
                </div>    
            )}

        </Stack>

    </>

}

